import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useMotion } from '@vueuse/motion'
import chroma from 'chroma-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'pointer-fx',
  props: {
    colorStart: null,
    colorEnd: null
  },
  setup(__props: any) {

const { colorStart = '#ffffff', colorEnd = '#ffffff' } = __props as { 
    colorStart?: string, 
    colorEnd?: string 
}



// let colorStart = '#ffffff';
// let colorEnd = '#ffffff';

/**
 * Creates a `div` element with class `k-pointer-fx` at the pointer event position and 
 * then begins a transition from `colorStart` to `colorEnd` over `duration` milliseconds,
 * as well as increasing the scale from 0 to 1 over the same duration.
 */
const container = ref<HTMLElement>();
const stopMotions = new Set<Function>();
const pointerEls = new Set<HTMLElement>();
const handleDocumentPointerDown = (e: PointerEvent) => {
    let el = document.createElement('div');

    let containerRect = container.value?.getBoundingClientRect();
    if (containerRect == null) return;

    el.classList.add('k-pointer-fx');
    el.style.left = `${(e.pageX - containerRect?.left) - 50}px`;
    el.style.top = `${(e.pageY - containerRect?.top) - 50}px`;
    el.style.backgroundColor = chroma(colorStart).hex();
    el.style.transform = 'scale(0)';
    container.value?.appendChild(el);

    pointerEls.add(el);
    const { apply, stop } = useMotion(el, {
        initial: {
            opacity: 1,
            scale: 0,
            backgroundColor: chroma(colorStart).hex()
        },
        enter: {
            opacity: 0,
            scale: 5,
            backgroundColor: chroma(colorEnd).hex(),
            transition: {
                duration: 350,
                ease: 'easeOut',
                onComplete: () => stopMotions.delete(stop)
            }
        }
    });
    stopMotions.add(stop);
    apply('enter');
}

onMounted(() => document.addEventListener('pointerdown', handleDocumentPointerDown));
onBeforeUnmount(() => {
    stopMotions.forEach(stop => stop());
    pointerEls.forEach(el => container.value?.removeChild(el));
    document.removeEventListener('pointerdown', handleDocumentPointerDown)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "k-pointer-fx-container"
  }, null, 512))
}
}

})